import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Remove payment method',
    description: 'Header text for the remove payment method modal',
    id: '266KYu',
  },
  confirmButton: {
    defaultMessage: 'Remove',
    description: 'Text for the confirm button in the remove payment method modal',
    id: '0tsoV0',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    description: 'Text for the cancel button in the remove payment method modal',
    id: 'MIAKgH',
  },
  title: {
    defaultMessage: 'Are you sure you want to remove {paymentMethodName} as a payment method?',
    description: 'Title text for the remove payment method modal',
    id: 'Qe2AZE',
  },
  description: {
    defaultMessage:
      'If you do not want this payment method to be displayed in your list of payment options, click "remove" to remove it now.',
    description: 'Description text for the remove payment method modal',
    id: '1Cp4Fb',
  },
  deleteSuccess: {
    defaultMessage: 'Payment method removed successfully.',
    description: 'Success message after removing a payment method',
    id: 'ElhRrC',
  },
  deleteError: {
    defaultMessage: 'There was an error removing the payment method. Please try again later.',
    description: 'Error message when removing a payment method fails',
    id: 'oPeFDe',
  },
});
